import { render, staticRenderFns } from "./sortable-group-list.vue?vue&type=template&id=ae2f6aca&scoped=true&lang=pug&"
import script from "./sortable-group-list.vue?vue&type=script&lang=ts&"
export * from "./sortable-group-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2f6aca",
  null
  
)

export default component.exports